import React from "react";
import { Chip, Menu, MenuItem, Fade } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import axios from "axios";
import { useDispatch } from "react-redux";
import { RestaurantAction } from "../Store/Reducers/Restaurant-reducer";
import { ReqListActions } from "../Store/Reducers/NewReqList-reducer";
import { RestaurantData } from "src/__Tests__/Helpers/DummyData";
import { licenseApiKeysActions } from "src/Store/Reducers/LicenseApiKeys-reducer";
const useStyles = makeStyles((theme) => ({
  active: {
    backgroundColor: "#09C491",
    color: "#fff",
    width: 116,
    "&:focus": {
      backgroundColor: "#09C491 !important",
    },
  },
  Pending: {
    backgroundColor: "#c0d3e2",
    color: "#747474",
    width: 116,
  },
  inactive: {
    backgroundColor: "#ff4d4d",
    color: "#fff",
    width: 116,
    "&:focus": {
      backgroundColor: "#ff4d4d !important",
    },
  },
  Accepted: {
    backgroundColor: "#09C491",
    color: "#fff",
    width: 116,
    "&:focus": {
      backgroundColor: "#09C491 !important",
    },
  },
  Declined: {
    backgroundColor: "#ff4d4d",
    color: "#fff",
    width: 116,
    "&:focus": {
      backgroundColor: "#ff4d4d !important",
    },
  },
}));

const StatusChip = ({
  data,
  getData,
  setLoading,
  handleSnackbarOpen,
  isLoading,
  index,
  comp,
  statusKey,
  apiUrl,
  itemId,
  handleApiKeyStatus,
}) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = async (statusName) => {
    const stat = statusName === "Inactive" ? "disable" : "enable";
    const newStatus = statusName === "Inactive" ? false : true;
    try {
      let response = await axios.get(`${apiUrl}${stat}`);
      if (response) {
        let obj = { ...data[index], status: newStatus };
        let finalRestaurantData = [...data];
        finalRestaurantData[index] = obj;
        dispatch(RestaurantAction.changeStatus(finalRestaurantData));
      }
    } catch (err) {
      handleSnackbarOpen("Status could not be changed", "errorDark");
    }
    handleClose();
  };

  const handleLead = async (status, id) => {
    try {
      let response = await axios.post(
        process.env.REACT_APP_API_URL + `restaurant/request/${id}/status`,
        {
          lead_status: status,
        }
      );
      if (response) {
        let obj = { ...data[index], lead_status: status };
        let finalRestaurantData = [...data];
        finalRestaurantData[index] = obj;
        dispatch(ReqListActions.changeStatus(finalRestaurantData));
      }
    } catch (err) {
      handleSnackbarOpen("Status could not be changed", "errorDark");
    }
    handleClose();
  };

  const handleApiKeysStatus = async (status) => {
    let obj = {
      created: data[index].created,
      is_authorized: [],
      status: status,
      api_key_name: data[index].api_key_name,
    };
    try {
      let response = await axios.post(
        `${process.env.REACT_APP_API_URL}update/apikey/${data[index].restaurant_id}?api_key=${data[index].api_key}`,
        obj
      );
      if (response) {
        dispatch(
          licenseApiKeysActions.changeStatus({
            status,
            api_key: data[index].api_key,
          })
        );
        handleApiKeyStatus && handleApiKeyStatus(index, status);
      }
    } catch (err) {
      handleSnackbarOpen("Something went wrong!", "errorDark");
    }
    handleClose();
  };

  return (
    <>
      <Chip
        className={
          classes[
            data[index].status !== undefined && data[index].status === true
              ? "active"
              : data[index].status !== undefined && data[index].status === false
              ? "inactive"
              : data[index]?.status === "PENDING"
              ? "Pending"
              : data[index]?.status === "APPROVED"
              ? "Accepted"
              : data[index]?.status === "DECLINED"
              ? "Declined"
              : data[index].lead_status
          ]
        }
        label={
          data[index].status === true
            ? "Active"
            : data[index].status === false
            ? "Inactive"
            : data[index].lead_status
            ? data[index].lead_status
            : data[index].status
            ? data[index].status
            : ""
        }
        onClick={handleClick}
        data-testid={
          data[index].status === true
            ? `active_rest_${itemId}`
            : data[index].status === false
            ? `inactive_rest_${itemId}`
            : data[index].lead_status
            ? `${data[index].lead_status}_req_${itemId}`
            : data[index].status
            ? `${data[index].status}_api_key_${itemId}`
            : ""
        }
      />

      {comp === "restaurants" &&
        (data[index].status === true ? (
          <Menu
            id="fade-menu"
            anchorEl={anchorEl}
            keepMounted
            open={open}
            onClose={handleClose}
            TransitionComponent={Fade}
          >
            <MenuItem
              data-testid={`confirm_inactive_rest_${itemId}`}
              onClick={() => handleMenuItemClick("Inactive")}
            >
              Inactive
            </MenuItem>
          </Menu>
        ) : (
          <Menu
            id="fade-menu"
            anchorEl={anchorEl}
            keepMounted
            open={open}
            onClose={handleClose}
            TransitionComponent={Fade}
          >
            <MenuItem
              data-testid={`confirm_active_rest_${itemId}`}
              onClick={() => handleMenuItemClick("Active")}
            >
              Active
            </MenuItem>
          </Menu>
        ))}
      {comp === "license" &&
        (data[index].status === "PENDING" ? (
          <Menu
            id="fade-menu"
            anchorEl={anchorEl}
            keepMounted
            open={open}
            onClose={handleClose}
            TransitionComponent={Fade}
          >
            <MenuItem
              data-testid={`confirm_approved_apikey${itemId}`}
              onClick={() => handleApiKeysStatus("APPROVED")}
            >
              Approved
            </MenuItem>
            <MenuItem
              data-testid={`confirm_declined_apikey${itemId}`}
              onClick={() => handleApiKeysStatus("DECLINED")}
            >
              Declined
            </MenuItem>
          </Menu>
        ) : data[index].status === "APPROVED" ? (
          <Menu
            id="fade-menu"
            anchorEl={anchorEl}
            keepMounted
            open={open}
            onClose={handleClose}
            TransitionComponent={Fade}
          >
            <MenuItem
              data-testid={`confirm_pending_apikey${itemId}`}
              onClick={() => handleApiKeysStatus("PENDING")}
            >
              Pending
            </MenuItem>
            <MenuItem
              data-testid={`confirm_declined_apikey${itemId}`}
              onClick={() => handleApiKeysStatus("DECLINED")}
            >
              Declined
            </MenuItem>
          </Menu>
        ) : (
          <Menu
            id="fade-menu"
            anchorEl={anchorEl}
            keepMounted
            open={open}
            onClose={handleClose}
            TransitionComponent={Fade}
          >
            <MenuItem
              data-testid={`confirm_pending_apikey${itemId}`}
              onClick={() => handleApiKeysStatus("PENDING")}
            >
              Pending
            </MenuItem>
            <MenuItem
              data-testid={`confirm_approved_apikey${itemId}`}
              onClick={() => handleApiKeysStatus("APPROVED")}
            >
              Approved
            </MenuItem>
          </Menu>
        ))}
      {comp === "new_requests" &&
        (data[index].lead_status === "Accepted" ? (
          <Menu
            id="fade-menu"
            anchorEl={anchorEl}
            keepMounted
            open={open}
            onClose={handleClose}
            TransitionComponent={Fade}
          >
            <MenuItem
              name="Pending"
              onClick={(e) => {
                handleLead("Pending", data[index].id, data[index].owner_name);
              }}
              data-testid={`confirm_pending_req_${itemId}`}
            >
              Pending
            </MenuItem>
            <MenuItem
              name="Declined"
              onClick={(e) => {
                handleLead("Declined", data[index].id, data[index].owner_name);
              }}
              data-testid={`confirm_declined_req_${itemId}`}
            >
              Declined
            </MenuItem>
          </Menu>
        ) : data[index].lead_status === "Pending" ? (
          <Menu
            id="fade-menu"
            anchorEl={anchorEl}
            keepMounted
            open={open}
            onClose={handleClose}
            TransitionComponent={Fade}
          >
            <MenuItem
              name="Accepted"
              onClick={(e) => {
                handleLead("Accepted", data[index].id, data[index].owner_name);
              }}
              data-testid={`confirm_accepted_req_${itemId}`}
            >
              Accepted
            </MenuItem>
            <MenuItem
              name="Declined"
              onClick={(e) => {
                handleLead("Declined", data[index].id, data[index].owner_name);
              }}
              data-testid={`confirm_declined_req_${itemId}`}
            >
              Declined
            </MenuItem>
          </Menu>
        ) : (
          <Menu
            id="fade-menu"
            anchorEl={anchorEl}
            keepMounted
            open={open}
            onClose={handleClose}
            TransitionComponent={Fade}
          >
            <MenuItem
              name="Accepted"
              onClick={(e) => {
                handleLead("Accepted", data[index].id, data[index].owner_name);
              }}
              data-testid={`confirm_accepted_req_${itemId}`}
            >
              Accepted
            </MenuItem>
            <MenuItem
              name="Pending"
              onClick={(e) => {
                handleLead("Pending", data[index].id, data[index].owner_name);
              }}
              data-testid={`confirm_pending_req_${itemId}`}
            >
              Pending
            </MenuItem>
          </Menu>
        ))}
    </>
  );
};

export default StatusChip;
